export const iFrameWrapper = (target) => {
  const article = document.querySelector(target);
  if (!article) return;
  const iframes = article.querySelectorAll('iframe');
  if (iframes.length <= 0) return;
  iframes.forEach((iframe) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'video-wrapper';
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  });
};

export const journal = () => {
  iFrameWrapper('.article-template__content');
};
